module.exports = __webpack_public_path__ + "static/outofboxperformance-7940a172db5866e77a303b65a2ce725b.jpg";